$(document).ready(function () {
  try {
    const urlParams = new URLSearchParams(window.location.search);

    // Get the value of the 'shape' parameter
    const shape = urlParams.get("shape");

    advanced_filters.shape = shape;
  } catch (error) {}

  initialize();
});
function getColorDetail(color) {
  switch (color) {
    case "D":
    case "E":
    case "F":
      return "Colorless";

    case "G":
    case "H":
    case "I":
    case "J":
      return "Near colorless";

    case "K":
    case "L":
    case "M":
      return "Faintly colorless";

    default:
      return "-";
  }
}

function getClarityDetail(clarity) {
  switch (clarity) {
    case "FL":
    case "VVS1":
    case "VVS2":
    case "VS1":
    case "VS2":
      return "Very very slightly included.";

    case "SI1":
    case "SI2":
    case "I1":
    case "I2":
    case "I3":
      return "Eye Visible";

    default:
      return "-";
  }
}

function showCountDown() {
  $("#retry_message").show();

  let countdown = 2;

  const $countdownTarget = $("#retry_seconds"); // Assuming there's an element with id 'countdown'

  // Show the countdown every second
  const interval = setInterval(() => {
    $countdownTarget.html(countdown);

    countdown--;

    if (countdown < 0) {
      clearInterval(interval);

      $("#retry_message").hide();

      initialize(); // Recall the initialize function
    }
  }, 1000);
}

$(document).ready(function () {
  initialize();
});

function loadMore2() {
  offset++;

  errorCount = 0;

  retryLimit = 3;

  initialize();
}

function initialize(filter_changed = false) {
  if (filter_changed) {
    offset = 1;
  }

  advanced_filters.page = offset;

  console.log("advanced_filters", advanced_filters);

  ajaxMethod(
    __url.diamonds.index,
    method.get,
    advanced_filters,
    function (response) {
      $(".vrai_filter_section").removeClass("in-progress");

      total = response?.result?.total ?? 0;

      setData(response?.result?.data ?? [], filter_changed);

      // isLoadingScroll = false;
    },
    function (xhr, status, error) {
      $(".vrai_filter_section").removeClass("in-progress");

      errorDefaultCallBack(xhr, status, error, function () {
        if (xhr.status === 500 && errorCount < retryLimit) {
          showCountDown();

          errorCount++;
        }
      });

      // isLoadingScroll = false;
    },
    function () {
      $(".vrai_filter_section").addClass("in-progress");

      $(".load_more_container").html("");

      if (offset == 1 || filter_changed) {
        loadDummyData();
      } else {
        let html = `
                    <div class="load-more">
                       <div class="loader"></div>
                    </div>
                    `;
        $(".load_more_container").html(html);
      }
    }
  );
}

function loadDummyData() {
  let dummyDataHtml = "";

  for (let index = 0; index < 10; index++) {
    dummyDataHtml += `
                            <div class="listing-row-head">
                                <div class="row-head-item"><h6 class="m-0"></h6></div>
                                <div class="row-head-item"><h6 class="m-0"></h6></div>
                                <div class="row-head-item"><h6 class="m-0"></h6></div>
                                <div class="row-head-item"><h6 class="m-0"></h6></div>
                                <div class="row-head-item"><h6 class="m-0"></h6></div>
                                <div class="row-head-item"><h6 class="m-0"></h6></div>
                            </div>
                            <br>
                        `;
  }

  $(".list-container").html(`
        <div class="list-row loading-placeholder">
            ${dummyDataHtml}
        </div>
    `);
}
function getRowData(item, index) {
  // <div class="list-row" data-index="${index}" onclick="loadIframe(${index}, ${
  //   item?.video_image_url && item?.video_image_url != "" ? false : true
  // })">
  return `
            <div class="list-row" data-index="${index}">
                <div class="listing-row-head">
                    <div class="row-head-item"><h6 class="m-0">${
                      item?.certificate?.shape ?? "-"
                    }</h6></div>
                    <div class="row-head-item"><h6 class="m-0">${
                      (item?.certificate?.carats)?.toFixed(2) ?? "-"
                    }</h6></div>
                    <div class="row-head-item"><h6 class="m-0">${
                      item?.certificate?.color ?? "-"
                    }</h6></div>
                    <div class="row-head-item"><h6 class="m-0">${
                      item?.certificate?.clarity ?? "-"
                    }</h6></div>
                    <div class="row-head-item"><h6 class="m-0">${
                      item?.certificate?.cut ?? "-"
                    }</h6></div>
                    <div class="row-head-item"><h6 class="m-0">$ ${(
                      (item?.price ?? 0) * 2.1
                    )
                      .toFixed(2)
                      .toLocaleString()}</h6></div>
                </div>
            </div>
            `;
}
function addLoadMore() {
  $(".load_more_container").html("");

  if (total > 0) {
    let html = `
    <div class="filtered_details" style="text-align:center;background:#f5f4f4;padding:10px;">
    
 <h6 style="margin:0px;"><strong>Struggling to find your ideal diamond.</strong><br> We’ll custom cut and polish one exclusively for you,<br> any shape, any size.</h6><br>
 <a href="/pages/contact-us" style="color:#193a74">Contact our Diamond Experts </a>
    </div>
                <div class="load-more" onclick="loadMore2()">

                    Load More
                </div>
                `;
    $(".load_more_container").html(html);
  }
}
function isSupportedVideo(url) {
  const supportedFormats = [".mp4", ".webm", ".ogg"];
  return supportedFormats.some((format) => url.endsWith(format));
}

const videoLinks = {
  ROUND_D_FL:
    "https://cdn.shopify.com/videos/c/o/v/ccd3bc4ee3ad4cceb2b87db0bf1308a8.mp4",

};

function getVideoLink(shape, color, clarity) {
  const key = `${shape}_${color}_${clarity}`;
  // console.log("key", key);
  return (
    videoLinks[key] || "https://videos.diamondfoundry.com/626794-thumb.jpg"
  ); // Default video link or poster image
}
function generatePreview(item, index) {
  const shape = item?.certificate?.shape;
  const color = item?.certificate?.color;
  const clarity = item?.certificate?.clarity;
  // console.log("shapess", shape);
  const videoSrc = item?.video;
  //console.log("videoSRc", videoSrc);
  // Call the function to initialize lazy loading
lazyLoadIframes();
  return `
    <iframe data-src="${videoSrc}" 
    id="preview-video-${index}"
        width="100%" 
        height="450" 
        frameborder="0" 
        allow="autoplay; fullscreen" 
        allowfullscreen>
</iframe>
    `;
}

function getRowDetailData(item, index) {
  const itemData = {
    certificate: {
      shape: item?.certificate?.shape ?? "-",
      carats: item?.certificate?.carats ?? "-",
      color: item?.certificate?.color ?? "-",
      clarity: item?.certificate?.clarity ?? "-",
      cut: item?.certificate?.cut ?? "-",
      lab: item?.certificate?.lab ?? "-",
      depth: item?.certificate?.depth ?? "-",
      length: item?.certificate?.length ?? "-",
      width: item?.certificate?.width ?? "-",
      polish: item?.certificate?.polish ?? "-",
      symmetry: item?.certificate?.symmetry ?? "-",
      table: item?.certificate?.table ?? "-",
    },
    price: item?.price ?? 0,
    eyeClean: item?.eyeClean ?? "-",
    green: item?.green ?? "-",
    milky: item?.milky ?? "-",
    image: item?.video_image_url,
    supplierStockId: item?.supplierStockId ?? "-",
    id: item?.supplierStockId ?? "-",
  };

  // Convert the itemData object to a JSON string
  const jsonItemData = JSON.stringify(itemData);

  let videoUrl = item?.video && item?.video != "" ? item?.video : null;

  let preview = generatePreview(item, index);
  // let preview = `<img class="preview-image" style="width: 100%;object-fit: cover;" src="https://videos.diamondfoundry.com/626794-thumb.jpg" />`;
  // let preview = `<video id="preview-video-${index}" src="https://cdn.shopify.com/videos/c/o/v/d76644cbd0204aca870fa1a31748694f.mp4" preload="auto" autoplay="true" loop="true" poster="${
  //   item?.image ?? "https://videos.diamondfoundry.com/626794-thumb.jpg"
  // }" playsinline="" webkit-playsinline="" x5-playsinline="" muted="true" style="width: 100%; height: 250px;"></video>`;

  // if (item?.image && item?.image != "") {

  //     preview = `<img id="preview-image-${index}" data-index="${index}" data-video="${videoUrl}" class="preview-image" style="width: 100%;object-fit: cover;" src=${item?.image} />`;
  // } else if (videoUrl) {

  //     preview = '';
  // }

  // if (videoUrl && !isSupportedVideo(videoUrl)) {

  //     preview += `<iframe id="preview-iframe-${index}" class="iframe-container" data-index="${index}" data-src="${videoUrl ?? 'https://videos.diamondfoundry.com/626794.mp4'}" style="width: 100%;height: 325px;${item?.image && item?.image != "" ? 'display:none' : ''}" frameborder="0"  allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
  // } else if (videoUrl && isSupportedVideo(videoUrl)) {

  //     preview += `<video id="preview-video-${index}" src="${videoUrl ?? 'https://videos.diamondfoundry.com/626794.mp4'}" preload="auto" autoplay="" loop="" poster="${item?.image ?? 'https://videos.diamondfoundry.com/626794-thumb.jpg'}" playsinline="" webkit-playsinline="" x5-playsinline="" muted="true" style="width: 100%; height: 100%;${item?.image && item?.image != "" ? 'display:none' : ''}"></video>`;
  // }

  //console.log("string item", JSON.stringify(item));
  return `
            <div class="drawer py-3 px-0" id="drawer-${index}">
                <div class="row align-items-start">
                    <div class="col-md-6">
                        <div style="width: 100%; height: 100%;">
                            ${preview}
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="accordion">
                            <div class="accordion-item">
                                <div class="accordion-header">
                                    <p class="m-0"><b>Cut</b>: Perfect premium cut. <b>${
                                      item?.certificate?.cut ?? "-"
                                    }</b></p>
                                    <span class="accordion-icon">+</span></div>
                                <div class="accordion-content">
                                    <div class="d-flex gap-2 justify-content-between align-items-center">
                                        <p class="m-0">The quality of the cut determines how brilliant a diamond is. Life is too short for a diamond that is not brilliant. All of our diamonds are cut to perfection.</p>
                                        <img src="https://www.vrai.com/_next/image?url=https%3A%2F%2Fwww.datocms-assets.com%2F25216%2F1591918138-4c-cut.png&w=96&q=75" alt="diamond" class="img-fluid">
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <div class="accordion-header">
                                    <p class="m-0"><b>Color</b>: ${getColorDetail(
                                      item?.certificate?.color
                                    )}. <b>${
    item?.certificate?.color ?? "-"
  }</b></p>
                                    <span class="accordion-icon">+</span></div>
                                <div class="accordion-content">
                                    <img src="https://www.vrai.com/_next/image?url=https%3A%2F%2Fwww.datocms-assets.com%2F25216%2F1708011771-color-2-cropped.png&w=576&q=75" class="img-fluid" alt="">
                                    <p class="m-0">The human eye cannot distinguish between individual GIA color letter grades. Colorless diamonds are more rare but near-colorless ones offer greater value.</p>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <div class="accordion-header">
                                    <p class="m-0"><b>Clarity</b>: ${getClarityDetail(
                                      item?.certificate?.clarity
                                    )}. <b>${
    item?.certificate?.clarity ?? "-"
  }</b></p>
                                    <span class="accordion-icon">+</span></div>
                                <div class="accordion-content">
                                    <p class="m-0">Clarity describes how many and how large the inclusions are in a diamond.</p>
                                    <img src="https://www.vrai.com/_next/image?url=https%3A%2F%2Fwww.datocms-assets.com%2F25216%2F1678265893-clarity-2.png&w=576&q=75" class="img-fluid" alt="">
                                </div>
                            </div>
                            <div class="accordion-item">
                                <div class="accordion-header">
                                    <p class="m-0"><b>Diamond Details</b></p>
                                    <span class="accordion-icon">-</span></div>
                                <div class="accordion-content" style="display: block;">
                                   <p class="m-0">LAB: ${
                                     item?.certificate?.lab
                                   }</p>
                                    <p class="m-0">Polish: ${
                                      item?.certificate?.polish
                                    }</p>
                                    <p class="m-0">Symmetry: ${
                                      item?.certificate?.symmetry
                                    }</p>
                                    <p class="m-0">Table: ${
                                      item?.certificate?.table
                                    }</p>
                                    <p class="m-0">Length: ${
                                      item?.certificate?.length
                                    }</p>
                                    <p class="m-0">Width: ${
                                      item?.certificate?.width
                                    }</p>
                                    <p class="m-0">Depth Percentage: ${
                                      item?.certificate?.depthPercentage
                                    }</p>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <div class="accordion-header">
                                    <p class="m-0"><b>Origin</b>: New York</p>
                                    <span class="accordion-icon">+</span></div>
                                <div class="accordion-content">
                                    <p class="m-0">We know each diamond from the very first atom—gently grown in our certified zero-emissions. Then, each diamond is cut by our master craftspeople to the top 1% in the world for breathtaking brilliance, fire, and scintillation.</p>
                                    </div>
                            </div>
                            <!-- Add more accordion items as needed -->
                            
                            <button id="p_add_to_cart" product_data='${jsonItemData}' class="btn3 btn-dark p_add_to_cart" style="margin:10px;border: gray;padding: 5px;width: 100%;">Add to Cart</button>
                          
                        </div>
                    </div>
                </div>
            </div>
            `;
}
function selectCollection(button) {
  const item = button.getAttribute("data-item");

  // Parse the JSON string back into an object
  const collectionItem = JSON.parse(item);

  window.localStorage.setItem("collection", JSON.stringify(collectionItem));

  window.location = `/pages/ring?collection_id=427708612828`;
}
function setData(items, filter_changed = false) {
  //console.log("items", items);

  if (offset == 1 || filter_changed) {
    $(".list-container").html(total == 0 ? "No Record Found" : "");
  }

  items.forEach((item, index) => {
    const header = getRowData(item, currentIndex);

    const detail = getRowDetailData(item, currentIndex);

    $(".list-container").append(header + detail);

    currentIndex++;
  });

  addLoadMore();

  initializeDrawer();

  init360();
}
function lazyLoadIframes() {
  $(document).ready(function () {
    // Check if IntersectionObserver is supported
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const $iframe = $(entry.target);
            $iframe.attr('src', $iframe.data('src'));
            observer.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '200px'
      });

      $('iframe[data-src]').each(function () {
        observer.observe(this);
      });
    } else {
      // Fallback: load all iframes if IntersectionObserver is not supported
      $('iframe[data-src]').each(function () {
        $(this).attr('src', $(this).data('src'));
      });
    }
  });
}



function init360() {
  $(".preview-image").on("mouseenter", function () {
    const index = $(this).data("index");

    const videoUrl = $(this).data("video");

    $(`#preview-iframe-${index}`)?.show();

    $(`#preview-video-${index}`)?.show();

    if (videoUrl) {
      $(this).hide();
    }

    console.log("preview-iframe", $(`#preview-iframe-${index}`));

    if ($(`#preview-iframe-${index}`)) {
      loadIframe(index, true);
    }
  });

  $(".iframe-container").on("mouseenter", function () {
    const index = $(this).data("index");

    $(this).addClass("hovered-class");
  });
  $(".iframe-container").on("mouseleave", function () {
    const index = $(this).data("index");

    $(this).removeClass("hovered-class");
  });
}
